import React, { useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { Alert, Box, Button, CircularProgress, Container } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import { getColors } from '~/services/MerchandiseService';

import AddColorDialog from './AddColorDialog';
import ColorsTable from './ColorsTable';

export default function ShopPage() {
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);

  const { data, isLoading, error } = useQuery({
    queryKey: ['merchandise', 'colors'],
    queryFn: async ({ signal }) => {
      const response = await getColors({ signal });
      return response.result.colors.sort((a, b) => {
        if (a.parentColor && !b.parentColor) {
          return 1;
        }
        if (b.parentColor && !a.parentColor) {
          return -1;
        }
        return a.name.localeCompare(b.name);
      });
    },
  });

  return (
    <Container maxWidth="xl">
      <PageHeader title="SHOP">
        <Button variant="contained" color="primary" onClick={() => setIsAddDialogOpen(true)}>
          Add new color
        </Button>
      </PageHeader>

      <AddColorDialog open={isAddDialogOpen} onClose={() => setIsAddDialogOpen(false)} />

      {isLoading && (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      )}

      {error && (
        <Box mt={4}>
          <Alert severity="error">
            Error loading colors: {error instanceof Error ? error.message : 'Unknown error'}
          </Alert>
        </Box>
      )}

      {!isLoading && !error && <ColorsTable data={data} isLoading={isLoading} />}
    </Container>
  );
}
